/** @jsx jsx */
import React, { useMemo } from 'react';
import { jsx } from '@emotion/core';
import ExpandablePanel from 'components/ExpandablePanel';
import styles from './styles';
import useTranslate from 'hooks/useTranslate/useTranslate';
import { ShippingAddressType } from 'state/creditApplication';
interface ShippingAddressProps {
  shippingAddress: ShippingAddressType;
}

const ShippingAddress: React.FC<ShippingAddressProps> = props => {
  const { shippingAddress } = props;
  const t = useTranslate();

  const { mobilePhone } = shippingAddress;

  // Converts phone from 555555555 to (555) 555-5555
  const formattedMobilePhone = useMemo(
    () =>
      mobilePhone
        ? `(${mobilePhone.slice(0, 3)}) ${mobilePhone.slice(
            3,
            6,
          )}-${mobilePhone.slice(6, 10)}`
        : undefined,
    [mobilePhone],
  );
  return (
    <ExpandablePanel
      title={
        <span css={styles.panelText}>
          <img
            css={styles.panelIcon}
            src={`data:image/png;base64,${t(
              'unified.placeOrder.label.addressIcon',
            )}`}
            alt="Address"
          />
          <p css={styles.panelTitle}>
            {t('unified.placeOrder.label.shippingAddress')}
          </p>
          <p css={styles.panelSecondaryText}>{shippingAddress.address1}</p>
        </span>
      }
      panelName={'shippingAddress'}
    >
      {shippingAddress.firstName || shippingAddress.lastName ? (
        <div css={styles.panelText}>
          <p css={styles.panelContentTitle}>
            {shippingAddress.firstName}, {shippingAddress.lastName}
          </p>
        </div>
      ) : null}
      {shippingAddress.emailAddress ? (
        <div css={styles.panelText}>
          <p css={styles.panelContentTitle}>{shippingAddress.emailAddress}</p>
        </div>
      ) : null}
      {mobilePhone ? (
        <div css={styles.panelText}>
          <p css={styles.panelContentTitle}>
            {formattedMobilePhone ? formattedMobilePhone : null}
          </p>
        </div>
      ) : null}
      {shippingAddress.address1 ? (
        <div css={styles.panelText}>
          <p css={styles.panelContentTitle}>{shippingAddress.address1}</p>
        </div>
      ) : null}
      {shippingAddress.city || shippingAddress.state || shippingAddress.zip ? (
        <div css={styles.panelText}>
          <p css={styles.panelContentTitle}>
            {`${shippingAddress.city}, ${shippingAddress.state} ${shippingAddress.zip}`}
          </p>
        </div>
      ) : null}
      <p css={styles.panelFinePrint}>
        {t('unified.placeOrder.label.shippingAddressEdit')}
      </p>
    </ExpandablePanel>
  );
};

export default ShippingAddress;
